import React, { useState } from "react";
import PropTypes from "prop-types";
import { CustomButton } from "../../../../../../common/components";
import { translate } from "../../../../../../common/providers";
import styles from "./NotificationHistory.module.css";

export default function HistoryRow({ item }) {
	const [expanded, setExpanded] = useState(false);

	const formatDate = (dateString) => {
		if (!dateString) {
			return "-";
		}
		const date = new Date(dateString);
		const options = { weekday: "long", day: "numeric", month: "long", year: "numeric" };
		const formattedDate = date.toLocaleDateString("fr-FR", options);
		return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
	};

	const formatTime = (dateString) => {
		if (!dateString) {
			return "";
		}
		const date = new Date(dateString);
		const hours = date.getHours();
		const minutes = date.getMinutes().toString().padStart(2, "0");
		return `${hours}h${minutes}`;
	};

	return (
		<div className={styles.card}>
			<div className={styles.cardHeader}>
				<span className={styles.cardDate}>{formatDate(item.sentAt || item.createdAt)}</span>
				<span className={styles.cardTime}>{formatTime(item.sentAt || item.createdAt)}</span>
				<div className={styles.cardDivider} />
				<span className={styles.cardSender}>{item.senderName}</span>
			</div>

			<div className={styles.cardSubject}>{item.subject}</div>

			{expanded && (
				<div className={styles.cardDetails}>
					<div className={styles.detailSection}>
						<span className={styles.sectionLabel}>DOCUMENTS À NOTIFIER</span>
						<div className={styles.documentList}>
							{item.documents?.map((doc, index) => (
								<div key={doc.id || index} className={styles.documentItem}>
									{doc.name}
								</div>
							))}
						</div>
					</div>

					{item.territories && item.territories.length > 0 && (
						<div className={styles.detailSection}>
							<span className={styles.sectionLabel}>TERRITOIRES</span>
							<div className={styles.documentList}>
								{item.territories.map((t, i) => (
									<div key={t.id || i} className={styles.documentItem}>
										{t.name}
									</div>
								))}
							</div>
						</div>
					)}

					{item.recipientEmails && item.recipientEmails.length > 0 && (
						<div className={styles.detailSection}>
							<span className={styles.sectionLabel}>ADRESSES E-MAIL</span>
							<span className={styles.sectionValueEmail}>{item.recipientEmails.join(", ")}</span>
						</div>
					)}

					<div className={styles.detailSection}>
						<span className={styles.sectionLabel}>TYPE DE DIFFUSION</span>
						<span className={styles.sectionValue}>{item.distributionType}</span>
					</div>

					{item.summary && (
						<div className={styles.detailSection}>
							<span className={styles.sectionLabel}>RÉSUMÉ</span>
							<span className={styles.sectionValue}>{item.summary}</span>
						</div>
					)}
				</div>
			)}

			<div className={styles.cardFooter}>
				<CustomButton
					className={styles.toggleButton}
					color="primary"
					size="sm"
					variant="outlined"
					onClick={() => setExpanded(!expanded)}
				>
					{expanded
						? translate("document-center.distribution-notification.history.collapse", "Réduire")
						: translate("document-center.distribution-notification.history.expand", "Voir plus")}
				</CustomButton>
			</div>
		</div>
	);
}

HistoryRow.propTypes = {
	item: PropTypes.shape({
		sentAt: PropTypes.string,
		createdAt: PropTypes.string,
		senderName: PropTypes.string,
		subject: PropTypes.string,
		documents: PropTypes.arrayOf(
			PropTypes.shape({
				id: PropTypes.number,
				name: PropTypes.string,
			})
		),
		territories: PropTypes.arrayOf(
			PropTypes.shape({
				id: PropTypes.number,
				name: PropTypes.string,
			})
		),
		recipientEmails: PropTypes.arrayOf(PropTypes.string),
		distributionType: PropTypes.string,
		summary: PropTypes.string,
	}).isRequired,
};
